<template>
  <div>
    <div class="blockHeader">
        <div class="redBlock"></div>
        <div class="headerText">{{workInfo.name}}</div>
    </div>
    <div class="blockContent">
        <div class="blockItem">
            <div class="item_type1">
                <div class="itemLeft">作业名</div>
                <div class="itemRight">
                <span class="infoShow">{{workInfo.name}}</span>
                </div>
            </div>
            <div class="item_type1">
                <div class="itemLeft">作业类型</div>
                <div class="itemRight">
                <span class="infoShow">{{workTypeList[workInfo.workType]}}</span>
                </div>
            </div>
            <div class="item_type1">
                <div class="itemLeft">作业标段</div>
                <div class="itemRight">
                <span class="infoShow">{{workInfo.sectionName}}</span>
                </div>
            </div>
            <div class="item_type1">
                <div class="itemLeft">作业进度</div>
                <div class="itemRight">
                <span class="infoShow">{{workInfo.process}}%</span>
                </div>
            </div>
        </div>
        <div class="blockItem">
            <div class="item_type1">
                <div class="itemLeft">开始作业时间</div>
                <div class="itemRight">
                <span class="infoShow">{{workInfo.startTime}}</span>
                </div>
            </div>
            <div class="item_type1">
                <div class="itemLeft">最后作业时间</div>
                <div class="itemRight">
                <span class="infoShow">{{workInfo.endTime}}</span>
                </div>
            </div>
            <div class="item_type1">
                <div class="itemLeft">开始作业桩号</div>
                <div class="itemRight">
                <span class="infoShow">{{workInfo.workType==3||workInfo.workType==4?workInfo.startPileNum:'--'}}</span>
                </div>
            </div>
            <div class="item_type1">
                <div class="itemLeft">结束作业桩号</div>
                <div class="itemRight">
                <span class="infoShow">{{workInfo.workType==3||workInfo.workType==4?workInfo.endPileNum:'--'}}</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name      : 'app',
    data() {
      return {
       workTypeList:this.$store.state.workTypeList
      }
    },
    props:{
        workInfo: {
            type: Object,
            default: function () {
                return {};
            },
        },  
        
    },
    watch: {
    },
    computed:{

    },
    created(){

    },
    mounted(){

    },
    methods: {
        
    },
    components:{
            
    }
  }
</script>

<style lang="scss" scoped="">
    .blockHeader{
      width: 100%;
      height: 58px;
      position: relative;
      .redBlock{
          height: 18px;
          width: 4px;
          position: absolute;
          background-color: #E96B5A;
          top: 19px;
          left: 20px;
        }
        .headerText{
          height: 16px;
          line-height: 16px;
          color: #222222;
          display: inline-block;
          position: absolute;
          top: 21px;
          left: 34px;
          font-weight: 600;
        }
    }
    .blockContent{
      width: 97.7%;
      margin: 0 auto;
      border-top:1px solid rgba(225, 225, 225, 1);
      border-left:1px solid rgba(225, 225, 225, 1);
      
      .blockItem{
        display: flex;
        height: 45px;
        .item_type1{
          flex: 1;
        }
        .item_type2{
          flex: 2;
        }
        .itemLeft{
          width: 120px;
          height: 44px;
          float: left;
          background:rgba(242,242,245,1);
          border-bottom:1px solid rgba(225, 225, 225, 1);
          border-right:1px solid rgba(225, 225, 225, 1);
          line-height: 44px;
          padding-left: 15px;
          color: #555555;
          font-size: 14px;
        }
        .itemRight{
          // width: 100%;
          height: 44px;
          line-height: 44px;
          padding-left: 18px;
          color: #555555;
          font-size: 14px;

          overflow: hidden;
          border-bottom:1px solid rgba(225, 225, 225, 1);
          border-right:1px solid rgba(225, 225, 225, 1);
          .infoShow{
            width: 100%;
            height: 100%;
            border: 0;
            color: #555555;
            font-size: 14px;
          }
        }
      }
    }
</style>